// ----------------------------------------------------------------------

import { iconPaths } from '../../assets/icons/iconPaths';
import SvgColor from '../../components/svg-color/svg-color';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PinDropOutlinedIcon from '@mui/icons-material/PinDropOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import PortraitOutlinedIcon from '@mui/icons-material/PortraitOutlined';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import MobileFriendlyOutlinedIcon from '@mui/icons-material/MobileFriendlyOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
// import { Adb } from '@mui/icons-material';

export const getIconByName = (name: string) => {
  if (name === 'dashboard') {
    return <SvgColor src={iconPaths.dashboard} sx={{ width: '100%', height: '100%' }} />;
  } else {
    return (
      <SvgColor src={`assets/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
    );
  }
};

const navConfig = [
  {
    title: 'ໜ້າຫຼັກ',
    path: '/',
    icon: <SignalCellularAltIcon />,
  },
  {
    title: 'ເອກະສານ',
    path: '/document',
    icon: <SpaceDashboardOutlinedIcon />,
  },
  {
    title: 'ຜູ້ໃຊ້ແອັບ',
    path: '/client',
    icon: <PortraitOutlinedIcon />,
  },
  {
    title: 'ຜູ້ໃຊ້ເວັບ',
    path: '/user',
    icon: <PeopleAltOutlinedIcon />,
  },
  {
    title: 'ການຕັ້ງຄ່າ',
    path: '/settings',
    icon: <SettingsOutlinedIcon />,
    child: [
      {
        title: 'ພາກສ່ວນປາຍທາງ',
        path: '/settings/destination',
        icon: <NearMeOutlinedIcon />,
        child: [
          {
            title: 'ກະຊວງ - ໜ່ວຍງານ',
            path: '/settings/destination/ministry',
            icon: <HomeWorkOutlinedIcon />,
          },
          {
            title: 'ແຂວງປາຍທາງ',
            path: '/settings/destination/province',
            icon: <PinDropOutlinedIcon />,
          },
          {
            title: 'ກົມ',
            path: '/settings/destination/department',
            icon: <ApartmentOutlinedIcon />,
          },
        ],
      },
      {
        title: 'ຈັດການຕໍາແໜ່ງ',
        path: '/settings/position',
        icon: <LayersOutlinedIcon />,
        role: 2,
        child: [
          {
            title: 'ຕໍາແໜ່ງ',
            path: '/settings/position/all',
            icon: <LayersOutlinedIcon />,
          },
          {
            title: 'ໝວດໝູ່ຕໍາແໜ່ງ',
            path: '/settings/position/category',
            icon: <ManageAccountsOutlinedIcon />,
          },
        ],
      },
      {
        title: 'ປະເພດເອກະສານ',
        path: '/settings/doctype',
        icon: <DescriptionOutlinedIcon />,
      },
      {
        title: 'ບົດບາດຜູ້ໃຊ້',
        path: '/settings/role',
        icon: <AdminPanelSettingsOutlinedIcon />,
      },
      {
        title: 'ສິດທິການນຳໃຊ້',
        path: '/settings/permission',
        icon: <VpnKeyOutlinedIcon />,
      },
      {
        title: 'ແອັບເວີຊັນ',
        path: '/settings/app-version',
        icon: <MobileFriendlyOutlinedIcon />,
      },
      {
        title: 'ຈັດການ Cache',
        path: '/settings/cache-management',
        icon: <StorageOutlinedIcon />,
      },
    ],
  },
];

export default navConfig;
